<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">利用者取込</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <div class="">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group" :class="{ 'has-danger': errors.office_id }">
                      <label class="control-label">事業所</label>
                      <select-office v-model="office_id" v-validate="'required'" name="office_id"
                        data-vv-as="事業所" data-vv-validate-on="none" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <div class="form-group" :class="{ 'has-danger': errors.file }">
                      <label class="control-label">ファイル</label>
                      <input type="file" name="file" class="form-control" accept=".csv" v-validate="'required'"
                        data-vv-as="ファイル" data-vv-validate-on="none" @change="onFileChange" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-actions">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button type="submit" class="action-button btn btn-success btn-rounded" @click.prevent="save">
                      インポート
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
      <div class="row" v-show="Object.keys(errors).length > 0">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" @click="errorsClear" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error, fieldName) in errors" :key="fieldName">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import api from '@/libs/Api'
import SelectOffice from '@/components/SelectOffice.vue'
import { useExecutor } from '@/libs/Executor'
import { reactive, ref } from 'vue'
import { useForm } from 'vee-validate'
import * as yup from 'yup'
import { useToast } from 'vue-toastification'

const { exec } = useExecutor()
const toast = useToast()

const isProcessing = ref(false)
const inputs = reactive({
  file: null,
  office_id: null
})

const { handleSubmit, errors, defineField, resetForm } = useForm({
  validationSchema: {
    office_id: yup.string().label('事業所').required('${label}を入力してください。'),
    file: yup.mixed().label('ファイル').required('${label}を入力してください。')
  }
})

// eslint-disable-next-line camelcase
const [office_id] = defineField('office_id')
const [file] = defineField('file')

const onFileChange = (e) => {
  let files = e.target.files || e.dataTransfer.files
  inputs.file = files[0]
  file.value = files[0]
}

const errorsClear = () => {
  resetForm()
}

const save = () => {
  handleSubmit(async (value, { setErrors }) => {
    exec(async () => {
      isProcessing.value = true

      inputs.office_id = office_id.value

      const res = await api.importTeresaStandardUser(inputs)

      if (!res) return Promise.resolve()

      if (res.length !== 0) {
        const apiErrors = {}
        res.forEach((error, index) => {
          apiErrors[`line_${index + 1}`] = error
        })

        setErrors({
          file: '上記の行数が取り込めませんでした。',
          ...apiErrors
        })
      } else {
        toast.success('インポートに成功しました。')
      }

      isProcessing.value = false
    }).catch(() => {})
  })()
}

</script>

<style>
.data-actions {
  text-align: right;
}

.table th {
  background-color: #99abb4 !important;
}
</style>
